<template>
  <AppearFromLeft>
    <div class="wrapper">
      <div class="status-container data-container">
        <div class="status-row">
          <strong>{{ parseTranslation(OPTION) }}</strong>
          <strong>{{ parseTranslation(COUNT) }}</strong>
        </div>

        <hr class="divider" />

        <div
          class="status-row"
          v-for="statusConfig in statusExtractors"
          :key="statusConfig.label"
        >
          <span>{{ statusConfig.label }}</span>
          <span>{{ statusConfig.extractor(survey_status) }}</span>
        </div>
      </div>

      <div class="numbers-container">
        <div
          class="data-container number-container"
          v-for="numberConfig in numberExtractors"
          :key="numberConfig.label"
        >
          <img :src="getImgUrl(numberConfig.imageName)" :alt="numberConfig.label" />
          <span>{{ numberConfig.label }}</span>
          <span>{{ numberConfig.extractor(survey_status) }}</span>
        </div>
      </div>
    </div>
  </AppearFromLeft>
</template>

<script>
import AppearFromLeft from '@/components/AppearFromLeft'

import * as translationPerformance from './Performance.translations'

import { LANGUAGES } from '@/utils/constants'

const { default: translations, ...translationKeys } = translationPerformance

export default {
  name: 'Performance',

  components: {
    AppearFromLeft,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      LANGUAGES,
    }
  },

  props: {
    survey_status: {
      required: true,
      type: Object,
    },
  },

  computed: {
    statusExtractors() {
      const statusExtractors = [
        {
          label: this.parseTranslation(this.COMPLETES),
          extractor: ({ status }) => status.complete,
        },
        {
          label: this.parseTranslation(this.SCREENED),
          extractor: ({ status }) => status.screened,
        },
        {
          label: this.parseTranslation(this.QUALITY_SCREENED),
          extractor: ({ status }) => status.qualityscreened,
        },
        {
          label: this.parseTranslation(this.QUOTA_FULL),
          extractor: ({ status }) => status.quotafull,
        },
        {
          label: this.parseTranslation(this.DROPOUT),
          extractor: ({ status }) => status.dropout,
        },
        {
          label: this.parseTranslation(this.STARTS),
          extractor: ({ starts }) => starts,
        },
      ]

      return statusExtractors
    },

    numberExtractors() {
      const numberExtractors = [
        {
          label: this.parseTranslation(this.COMPLETE_RATE),
          imageName: 'Complete Rate',
          extractor: ({ rates }) => rates.complete,
        },
        {
          label: this.parseTranslation(this.INCIDENCE_RATE),
          imageName: 'Incidence Rate',
          extractor: ({ rates }) => rates.incidence,
        },
        {
          label: this.parseTranslation(this.DROPOUT_RATE),
          imageName: 'Dropout Rate',
          extractor: ({ rates }) => rates.dropout,
        },
        {
          label: this.parseTranslation(this.LOI),
          imageName: 'LOI',
          extractor: ({ rates }) => rates.loi,
        },
      ]

      return numberExtractors
    },
  },

  methods: {
    getImgUrl(stat) {
      return require(`@/assets/imgs/${stat}.png`)
    },
  },
}
</script>

<style lang="scss" scoped>
.data-container {
  border-radius: 8px;
  background: $gray-7;

  .light & {
    background: #eeeeee;
  }
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 1000px) {
    justify-content: center;
  }
}

.divider {
  /* inner padding */
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 2px;
  border: none;
  background: $gray;
}

.status-row {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.numbers-container,
.status-container {
  flex: 1 1;
  min-width: Min(100%, 500px);
  max-width: 500px;
  margin-top: 20px;
  color: $white;

  .light & {
    color: $main;
  }
}

.numbers-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: Min(100%, 450px);
  max-width: 450px;
}

.number-container {
  padding: 16px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1000px) {
    & + .number-container {
      margin-top: 20px;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;

    span {
      margin-top: 12px;
    }
  }

  img {
    @include boxSizing(36);
  }
}
</style>
